import { Component, OnInit, Renderer2, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label, ThemeService } from 'ng2-charts';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationService } from 'src/app/services/translation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-community-groups',
  templateUrl: './community-groups.component.html',
  styleUrls: ['./community-groups.component.css']
})

export class CommunityGroupsComponent implements OnInit {
  user = this.apiService.user;
  url = this.apiService.url + '/uploads/';
  selected: any;
  groups: Array<any> = [];
  menuState: string = 'out';
  aLoading: Boolean = false;
  oLoading: Boolean = false;
  myGroup = this.user.group;
  videoStatus: Boolean = false;
  defaultHomePage = '';
  video: String = 'assets/videos/Emotive registration tutorial.mp4';
  constructor(
    private apiService: ApiService,
    private renderer: Renderer2,
    private modalService: BsModalService,
    private router: Router,
    public translations: TranslationService
  ) { }

  ngOnInit() {
    this.getData(false);
    this.apiService.getClient().subscribe((res: any) => {
      this.defaultHomePage = res.data.defaultHomePage;
      if (res.data.video) {
        this.video = res.data.video;
      }
    });
  }

  modalRef: BsModalRef;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'tour-modal tutorial' });
  }

  toggleVideo(video) {
    !this.videoStatus ? video.play() : video.pause();
    this.videoStatus = !this.videoStatus;
  }

  navigateToDefault() {
    return this.router.navigate([`/${this.defaultHomePage ? this.defaultHomePage : 'dashboard'}`]);
  }

  getData(id) {
    this.apiService.getAllGroups().subscribe((res: any) => {
      this.groups = res.data;
      if (id) {
        this.aLoading = true;
        this.oLoading = true;
        let selected = this.groups.filter(data => data._id == id);
        let subs = selected[0].subscribers.map(s => s._id);
        this.apiService.getGroupActivity({ id: subs }).subscribe((resAct: any) => {
          this.aLoading = false;
          this.selected['activities'] = resAct.data;
        });
        this.apiService.getGroupOutcome({ id: subs }).subscribe((resOut: any) => {
          this.oLoading = false;
          this.selected['outcomes'] = resOut.data;
        });
        this.selected = selected[0];
      }
    });
  }


  join(group_id) {
    let users = [];
    users.push(this.user._id);
    this.myGroup.push(group_id);
    this.apiService.assignGroup({ group: this.myGroup, users: users }).subscribe((res: any) => {
      this.getData(group_id);
    });
  }

  unjoin(group_id) {
    let users = [];
    users.push(this.user._id);
    let index = this.myGroup.findIndex(data => data == group_id);
    this.myGroup.splice(index, 1);
    this.apiService.deAssignGroup({ group: this.myGroup, users: users }).subscribe((res: any) => {
      this.getData(group_id);
    });
  }

  joinedOrNot(subscribers) {
    if (subscribers) {
      let index = subscribers.findIndex(data => data._id == this.user._id);
      if (index >= 0) {
        return true;
      }
      return false;
    }
  }

  open(group) {
    this.selected = group;
    this.aLoading = true;
    this.oLoading = true;
    let subs = group.subscribers.map(s => s._id);
    this.apiService.getGroupActivity({ id: subs }).subscribe((resAct: any) => {
      this.aLoading = false;
      this.selected['activities'] = resAct.data;
    });
    this.apiService.getGroupOutcome({ id: subs }).subscribe((resOut: any) => {
      this.oLoading = false;
      this.selected['outcomes'] = resOut.data;
    });
    this.renderer.addClass(document.body, 'overlay');
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }

  aWidth(count) {
    let total = 0;
    if (this.selected && this.selected.activities) {
      this.selected['activities'].forEach((ele) => {
        total += parseInt(ele.count);
      });
      let percent: any = (count / total) * 100;
      return parseInt(percent);
    }
    return 0;
  }


  oWidth(count) {
    let total = 0;
    if (this.selected && this.selected.outcomes) {
      this.selected['outcomes'].forEach((ele) => {
        total += parseInt(ele.count);
      });
      let percent: any = (count / total) * 100;
      return parseInt(percent);
    }
    return 0;
  }

  closeGroup() {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
    this.renderer.removeClass(document.body, 'overlay');
  }

  public lineChartData: ChartDataSets[] = [
    {
      data: [43, 47, 37, 55, 40, 60, 50],
      label: 'A',
      lineTension: 0,
      pointBackgroundColor: 'rgba(0,0,0,0)',
      pointBorderColor: 'rgba(0,0,0,0)'
    },
  ];
  public lineChartLabels: Label[] = ['Mon 12', 'Tue 13', 'Wed 14', 'Thu 15', 'Fri 16', 'Sat 17', 'Sun 18'];
  public lineChartColors: Color[] = [
    {
      borderColor: '#2D91A3',
      backgroundColor: 'rgba(45, 145, 163, 0.1)',
    },
  ];
  public lineChartLegend = false;
  public lineChartType = 'line';
  public lineChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          display: false
        }
      }],

      yAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          display: false,
          min: 0
        }
      }]
    }
  }
}
